define('modules/accounts/companies/detail/form-company-view',['require','exports','module','views/BaseView','ldsh!./form-company-template'],function(require, exports, module) {
    "use strict";

    var BaseView = require("views/BaseView");

    var View = BaseView.extend({
        template: require("ldsh!./form-company-template"),
        initialize: function() {},
        serialize: function() {
            return {
                newCompany: !this.model.get("id"),
                company: this.model,
                groupId: this.options.groupId
            };
        }
    });

    module.exports = View;
});

